import { render, staticRenderFns } from "./DatepickerDemo.vue?vue&type=template&id=3be759e7&"
import script from "./DatepickerDemo.vue?vue&type=script&lang=js&"
export * from "./DatepickerDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports